import { Button, Card, Col, Form, Input, message, Row, Select, Spin, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
import Post from '../services/Post';
import { useNavigate } from 'react-router-dom';
import { stringify } from 'flatted';

const Electricity = () => {
    const [operator, setOperator] = useState([]);
    const [selectedOperator, setSelectedOperator] = useState();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        display: '',
        ad1: '',
        ad2: '',
        ad3: ''
    });
    const navigate = useNavigate();

    const getOperator = () => {
        setLoading(true);
        Post.ElectricityOperator().then((res) => {
            console.log('operator', res);
            setOperator(Array.isArray(res.data) ? res.data : []);
        }).catch((err) => {
            message.error(err);
        }).finally(() => {
            setLoading(false);
        })
    }

    const handleSelectOperator = (value) => {
        const selected = operator.find((op) => op.id === value);
        setSelectedOperator(selected);
        console.log('Selected Operator:', selected);
    };

    const handleInputChange = (text, field) => {
        setFormData((prevState) => ({ ...prevState, [field]: text }));
    };

    const getInputProperties = (regex) => {
        let maxLength = 0;

        if (regex?.startsWith('^[6789]')) {
            maxLength += 1;
        }

        const lengthMatches = regex?.match(/{(\d+)(?:,(\d+))?}/g);

        if (lengthMatches) {
            maxLength += lengthMatches.reduce((acc, match) => {
                const [, min, max] = match.match(/{(\d+)(?:,(\d+))?}/);
                return acc + (max ? parseInt(max, 10) : parseInt(min, 10));
            }, 0);
        }

        return maxLength > 0 ? { maxLength } : null
    };

    const nextPage = () => {
        localStorage.setItem('operator', JSON.stringify(selectedOperator));
        localStorage.setItem('formData', stringify(formData));
        navigate('/user/bill-details', { state: { type: 'Electricity' } });
    }

    useEffect(() => {
        getOperator();
    }, [])

    return (
        <div className="layout-content">
            <Row className='form-row'>
                <Col xs={16}>
                    <Card bordered={false} className="criclebox h-full">
                        <Typography.Title level={5}>Select Electricity Operator</Typography.Title>
                        <Spin spinning={loading}>
                            <Select
                                showSearch
                                placeholder="Select an Operator"
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                className='operator-select'
                                size='large'
                                onChange={handleSelectOperator}
                                options={operator.map((op) => ({
                                    value: op.id, // Replace `id` with the appropriate key from your API response
                                    label: op.name, // Replace `name` with the appropriate key from your API response
                                }))}
                            />
                        </Spin>
                    </Card>
                </Col>
            </Row>

            {selectedOperator && (
                <Row className='form-row'>
                    <Col xs={16}>
                        <Card bordered={false} className="criclebox h-full">
                            <Form
                                name="layout-multiple-vertical"
                                layout="vertical"
                                labelCol={{
                                    span: 24,
                                }}
                                wrapperCol={{
                                    span: 24,
                                }}
                            >
                                {(selectedOperator.displayname && selectedOperator.displayname !== "null") && (
                                    <>
                                        <Typography.Title level={5}>{selectedOperator.displayname}</Typography.Title>
                                        <Input
                                            size='small'
                                            placeholder='Enter ...'
                                            className="mb-4"
                                            onChange={(text) => handleInputChange(text.target.value, 'display')}
                                            {...getInputProperties(selectedOperator.regex)}
                                            onKeyDown={(e) => {
                                                const { key, ctrlKey, metaKey } = e.nativeEvent;

                                                // Allow shortcuts like Ctrl+V (paste) and Command+V (on macOS)
                                                if ((ctrlKey || metaKey) && key.toLowerCase() === 'v') {
                                                    return; // Allow pasting
                                                }

                                                // Validate numeric input
                                                if (selectedOperator.regex?.includes("[0-9") && !/^\d$/.test(key) && key !== "Backspace") {
                                                    e.preventDefault(); // Prevent non-numeric input except backspace
                                                }
                                            }}
                                            onPaste={(e) => {
                                                const pasteData = e.clipboardData.getData('text');
                                                // Check if pasted data matches the regex
                                                if (!new RegExp(selectedOperator.regex).test(pasteData)) {
                                                    e.preventDefault(); // Prevent invalid paste
                                                }
                                            }}
                                        />
                                    </>
                                )}

                                {(selectedOperator.ad1_d_name && selectedOperator.ad1_d_name !== "null") && (
                                    <>
                                        <Typography.Title level={5}>{selectedOperator.ad1_d_name}</Typography.Title>
                                        <Input
                                            size='small'
                                            placeholder='Enter ...'
                                            className="mb-4"
                                            onChange={(text) => handleInputChange(text.target.value, 'ad1')}
                                            {...getInputProperties(selectedOperator.ad1_regex)}
                                            onKeyDown={(e) => {
                                                const { key, ctrlKey, metaKey } = e.nativeEvent;

                                                // Allow shortcuts like Ctrl+V (paste) and Command+V (on macOS)
                                                if ((ctrlKey || metaKey) && key.toLowerCase() === 'v') {
                                                    return; // Allow pasting
                                                }

                                                // Validate numeric input
                                                if (selectedOperator.ad1_regex?.includes("[0-9") && !/^\d$/.test(key) && key !== "Backspace") {
                                                    e.preventDefault(); // Prevent non-numeric input except backspace
                                                }
                                            }}
                                            onPaste={(e) => {
                                                const pasteData = e.clipboardData.getData('text');
                                                // Check if pasted data matches the regex
                                                if (!new RegExp(selectedOperator.ad1_regex).test(pasteData)) {
                                                    e.preventDefault(); // Prevent invalid paste
                                                }
                                            }}
                                        />
                                    </>
                                )}

                                {(selectedOperator.ad2_d_name && selectedOperator.ad2_d_name !== "null") && (
                                    <>
                                        <Typography.Title level={5}>{selectedOperator.ad2_d_name}</Typography.Title>
                                        <Input
                                            size='small'
                                            placeholder='Enter ...'
                                            className="mb-4"
                                            onChange={(text) => handleInputChange(text.target.value, 'ad2')}
                                            {...getInputProperties(selectedOperator.ad2_regex)}
                                            onKeyDown={(e) => {
                                                const { key, ctrlKey, metaKey } = e.nativeEvent;

                                                // Allow shortcuts like Ctrl+V (paste) and Command+V (on macOS)
                                                if ((ctrlKey || metaKey) && key.toLowerCase() === 'v') {
                                                    return; // Allow pasting
                                                }

                                                // Validate numeric input
                                                if (selectedOperator.ad2_regex?.includes("[0-9") && !/^\d$/.test(key) && key !== "Backspace") {
                                                    e.preventDefault(); // Prevent non-numeric input except backspace
                                                }
                                            }}
                                            onPaste={(e) => {
                                                const pasteData = e.clipboardData.getData('text');
                                                // Check if pasted data matches the regex
                                                if (!new RegExp(selectedOperator.ad2_regex).test(pasteData)) {
                                                    e.preventDefault(); // Prevent invalid paste
                                                }
                                            }}
                                        />
                                    </>
                                )}

                                {(selectedOperator.ad3_d_name && selectedOperator.ad3_d_name !== "null") && (
                                    <>
                                        <Typography.Title level={5}>{selectedOperator.ad3_d_name}</Typography.Title>
                                        <Input
                                            size='small'
                                            placeholder='Enter ...'
                                            className="mb-4"
                                            onChange={(text) => handleInputChange(text.target.value, 'ad3')}
                                            {...getInputProperties(selectedOperator.ad3_regex)}
                                            onKeyDown={(e) => {
                                                const { key, ctrlKey, metaKey } = e.nativeEvent;

                                                // Allow shortcuts like Ctrl+V (paste) and Command+V (on macOS)
                                                if ((ctrlKey || metaKey) && key.toLowerCase() === 'v') {
                                                    return; // Allow pasting
                                                }

                                                // Validate numeric input
                                                if (selectedOperator.ad3_regex?.includes("[0-9") && !/^\d$/.test(key) && key !== "Backspace") {
                                                    e.preventDefault(); // Prevent non-numeric input except backspace
                                                }
                                            }}
                                            onPaste={(e) => {
                                                const pasteData = e.clipboardData.getData('text');
                                                // Check if pasted data matches the regex
                                                if (!new RegExp(selectedOperator.ad3_regex).test(pasteData)) {
                                                    e.preventDefault(); // Prevent invalid paste
                                                }
                                            }}
                                        />
                                    </>
                                )}
                                <Button className='form-btn' onClick={nextPage}>Proceed</Button>
                            </Form>
                        </Card>
                    </Col>
                </Row>
            )}
        </div>
    )
}

export default Electricity